export type VolumeIcon = 'rhythm' | 'harmony' | 'standards' | 'assessment' | 'cards' | 'planner'

export interface Volume {
  number: string
  title: string
  description: string
  contents: string[]
  icon: VolumeIcon
  /** Accent color for the volume's icon tile. */
  accent: string
}

export const volumes: Volume[] = [
  {
    number: '01',
    title: 'Rhythmic Foundations Master-Vault',
    description:
      '50 complete sessions on swing feel, comping patterns, and rhythmic architecture — all with structured progressions.',
    contents: ['Swing Feel', 'Basic Comping', 'Groove Mastery', 'Rhythm Drills'],
    icon: 'rhythm',
    accent: '#2E5B4A',
  },
  {
    number: '02',
    title: 'Harmonic Excellence',
    description:
      'Chord theory, ii-V-I mastery, voice leading, and harmonic substitutions — lesson by lesson progression.',
    contents: ['7th Chords', 'ii-V-I in All Keys', 'Tritone Subs', 'Voice Leading'],
    icon: 'harmony',
    accent: '#1F3A5F',
  },
  {
    number: '03',
    title: 'The Standards Collection',
    description:
      '50 complete sessions with mapped-out standards including melody, comping, and improvisation guides.',
    contents: ['Autumn Leaves', 'Blue Bossa', 'So What', '+ 17 more'],
    icon: 'standards',
    accent: '#C08A2E',
  },
  {
    number: '04',
    title: 'The Assessment Toolkit',
    description:
      'Ready-to-use rubrics, progress tracking sheets, and evaluation forms for student advancement.',
    contents: ['Rubrics', 'Progress Sheets', 'Level-Up Criteria', 'Feedback Templates'],
    icon: 'assessment',
    accent: '#4A3524',
  },
  {
    number: '05',
    title: 'Visual Cues & Technique Cards',
    description:
      '120+ visual reference cards for explaining technique, chord shapes, and correcting common mistakes instantly.',
    contents: ['120+ Technique Cards', 'Correction Guides', 'Visual References'],
    icon: 'cards',
    accent: '#8E3232',
  },
  {
    number: '06',
    title: 'The Annual Planner',
    description:
      'Complete calendar with 52 weeks of lessons mapped out, plus monthly teaching objectives.',
    contents: ['52-Week Calendar', 'Unit Maps', 'Monthly Goals', 'Checkpoints'],
    icon: 'planner',
    accent: '#2B4A4E',
  },
]
